import { SurveyTemplate } from "../../../../../features/organization/survey/survey.type";

interface DetailsTemplateImageProps {
  SurveyData: SurveyTemplate;
}

export default function DetailsTemplateImage({
  SurveyData,
}: DetailsTemplateImageProps) {
  return (
    <>
      <div className="w-full h-60 bg-black/20 rounded-lg">
        <img
          src={SurveyData?.cover_image}
          alt="survey_image"
          className="rounded-lg w-full h-full"
        />
      </div>
    </>
  );
}
